import { FunctionComponent, ReactNode } from 'react';

import { includes, last, some } from 'libraries/lodash'

import { QA_CONTENT } from 'constants/controllers'
import { AccordionGroup } from 'interfaces/accordion';

const SmartFcCrossReferenceLink: FunctionComponent<SmartFcCrossReferenceLinkProps> = ({
  href: _href,
  children,
  setAccordionExpandedNodeId,
  setAccordionExpandedNodeTitle,
  expandedNodeId,
  sectionId,
  group,
  isLimitedAccess,
  setUserRolesModalIsOpen,
  setUserRolesModalIsBasicMessage,
  flavour,
  aol
}) => {
  let href = _href
  const hrefPath = _href.split('/')
  // Additional check added as part of FC-1834
  // if the link isn't in the same section fall back on the other detections for incorrect roles
  const validLink = !href.includes(sectionId) ||
    some(group, node =>
      node.id === _href ||
      node.sectionIds.includes(last(hrefPath))
    )

  if (hrefPath[0] && hrefPath[0] === QA_CONTENT) {
    hrefPath.reverse()
    hrefPath.push(flavour)
    hrefPath.push(aol)
    hrefPath.reverse()
    href = hrefPath.join('/')
  } else {
    if (includes(hrefPath, QA_CONTENT)) {
      hrefPath.reverse()
      hrefPath.push(aol)
      hrefPath.reverse()
      href = hrefPath.join('/')
    }
  }

  const handleOnClick = () => {
    if (isLimitedAccess && !validLink) {
      // partial solution to FC-1528, show role modal to core users when link is premium
      setUserRolesModalIsBasicMessage(true)
      setUserRolesModalIsOpen(true)
    }

    const linkId = hrefPath[hrefPath.length - 1]
    const linkGroupWithTocIds = group.filter((groupNode: AccordionGroup) => (groupNode.tocIds || []).some((id:string) => id === linkId)) // share pages can't generate tocs
    const linkGroupWithSectionIds = group.filter((groupNode: AccordionGroup) => (groupNode.tocIds || []).some((id:string) => id === linkId))

    if (linkGroupWithTocIds.length > 0 && linkGroupWithTocIds[0].id !== expandedNodeId) {
      setAccordionExpandedNodeTitle(linkGroupWithTocIds[0].title)
      setAccordionExpandedNodeId(linkGroupWithTocIds[0].id)
    } else if (linkGroupWithSectionIds.length > 0 && linkGroupWithSectionIds[0].id !== expandedNodeId) {
      setAccordionExpandedNodeTitle(linkGroupWithSectionIds[0].title)
      setAccordionExpandedNodeId(linkGroupWithSectionIds[0].id)
    }
  }

  return (
    <a
      className='fc-cross-reference'
      href={isLimitedAccess && !validLink ? null : href}
      onClick={handleOnClick}
    >
      {children}
    </a>
  )
}

interface SmartFcCrossReferenceLinkProps {
  href: string;
  children: ReactNode;
  setAccordionExpandedNodeId: (value: string) => void;
  setAccordionExpandedNodeTitle: (value: string) => void;
  expandedNodeId: string;
  sectionId: string;
  group: AccordionGroup[];
  isLimitedAccess: boolean;
  setUserRolesModalIsOpen: (value: boolean) => void;
  setUserRolesModalIsBasicMessage: (value: boolean) => void;
  flavour: string;
  aol: string;
}

export default SmartFcCrossReferenceLink
